function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#72246c",
  d: "M10.637 4.896l-.162.115-1.24-1.134c.79-.7 1.561-.996 2.5-1.041l.26-.006c2.223 0 4.04 1.744 4.16 3.938l.006.229v1.666h.833c.862 0 1.577.665 1.658 1.507l.008.16v8.333c0 .863-.664 1.578-1.506 1.66l-.16.007H6.996c-.862 0-1.577-.664-1.658-1.507l-.008-.16V10.33c0-.863.664-1.578 1.506-1.659l.16-.008h7.498V6.997c0-1.384-1.116-2.5-2.499-2.5-.501 0-.967.146-1.358.399zm6.357 5.434H6.996v8.333h9.998V10.33zm-4.999 2.5c.916 0 1.666.75 1.666 1.667 0 .862-.664 1.578-1.506 1.659l-.16.007c-.916 0-1.666-.75-1.666-1.666 0-.863.664-1.578 1.506-1.66l.16-.007z"
});
const SvgIcLockOff = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcLockOff, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-lock-off.bd746a8c.svg";
export { ForwardRef as ReactComponent };